import { render } from "./PinModalDelete.vue?vue&type=template&id=8b0ac504&scoped=true"
import script from "./PinModalDelete.vue?vue&type=script&lang=js"
export * from "./PinModalDelete.vue?vue&type=script&lang=js"

import "./PinModalDelete.vue?vue&type=style&index=0&id=8b0ac504&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-8b0ac504"

export default script